import { createContext, useContext, useState } from "react";

const dict = {
  es: {
    appName: "UG Managment by OOMINING",
    tagline: "UG Mine Management",
    login: "Iniciar Sesión", email: "Correo electrónico", password: "Contraseña", signIn: "Ingresar", logout: "Cerrar sesión",
    dashboard: "Panel de Control", projects: "Proyectos", safety: "Seguridad", users: "Usuarios", schedule: "Cronograma",
    costs: "Costos", overview: "Resumen", tasks: "Tareas",
    activeProjects: "Proyectos Activos", totalBudget: "Presupuesto Total", actualCost: "Costo Real", avgProgress: "Avance Promedio",
    openIncidents: "Incidentes Abiertos", daysLost: "Días Perdidos", frequencyRate: "Índice de Frecuencia", severityRate: "Índice de Severidad",
    budgetVsActual: "Presupuesto vs Real", incidentsByType: "Incidentes por Tipo", projectPortfolio: "Cartera de Proyectos",
    newProject: "Nuevo Proyecto", name: "Nombre", code: "Código", status: "Estado", startDate: "Fecha Inicio", endDate: "Fecha Fin",
    budget: "Presupuesto", manager: "Responsable", area: "Área / Nivel", description: "Descripción", progress: "Avance",
    planning: "Planificación", active: "Activo", on_hold: "En Pausa", completed: "Completado",
    save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", actions: "Acciones", create: "Crear",
    newTask: "Nueva Tarea", phase: "Fase", assignee: "Asignado a", dependsOn: "Depende de", none: "Ninguna",
    development: "Desarrollo", drilling: "Perforación y Voladura", hauling: "Acarreo", ground_support: "Sostenimiento",
    services: "Servicios", ventilation: "Ventilación", other: "Otro",
    newCost: "Nuevo Costo", category: "Categoría", amount: "Monto", date: "Fecha", type: "Tipo",
    labor: "Mano de Obra", equipment: "Equipos", materials: "Materiales", explosives: "Explosivos",
    planned: "Planificado", actual: "Real", total: "Total", variance: "Variación",
    incidents: "Incidentes", inspections: "Inspecciones", newIncident: "Nuevo Incidente", newInspection: "Nueva Inspección",
    near_miss: "Casi Accidente", first_aid: "Primeros Auxilios", medical_treatment: "Tratamiento Médico",
    lost_time: "Tiempo Perdido", fatality: "Fatalidad", severity: "Severidad",
    open: "Abierto", investigating: "En Investigación", closed: "Cerrado",
    inspector: "Inspector", findings: "Hallazgos", compliance: "Cumplimiento", avgCompliance: "Cumplimiento Promedio",
    totalIncidents: "Incidentes Totales", ltiIncidents: "Incidentes con Tiempo Perdido",
    newUser: "Nuevo Usuario", role: "Rol", admin: "Administrador", supervisor: "Supervisor", viewer: "Visualizador",
    managerRole: "Gerente", createdAt: "Creado",
    jefaturaRole: "Jefatura", almacenistaRole: "Almacenista", mecanicoRole: "Mecánico", operadorRole: "Operador",
    userSourceManual: "Manual", userSourceFromHR: "Desde Nómina",
    selectEmployee: "Selecciona un empleado…", noHRCandidates: "No hay empleados de Nómina sin usuario",
    welcomeBack: "Bienvenido de vuelta", loginSubtitle: "Sistema integral de gestión para minería subterránea",
    secTitle: "Sistema de Seguridad Anti-Hackeo",
    secSubtitle: "Su información está protegida con seguridad de nivel empresarial",
    secEncryption: "Contraseñas cifradas con bcrypt",
    secEncryptionDesc: "Las contraseñas se almacenan con hash irreversible; ni siquiera los administradores pueden verlas.",
    secTokens: "Sesiones con tokens JWT firmados",
    secTokensDesc: "Cookies httpOnly seguras que impiden el robo de sesión por scripts maliciosos (anti-XSS).",
    secBruteForce: "Bloqueo anti fuerza bruta",
    secBruteForceDesc: "Tras 5 intentos fallidos la cuenta se bloquea 15 minutos y cada IP tiene un límite global de intentos.",
    secHeaders: "Blindaje HTTP del navegador",
    secHeadersDesc: "Cabeceras de seguridad (HSTS, anti-clickjacking, anti-sniffing) en cada respuesta del servidor.",
    secAudit: "Auditoría de seguridad 24/7",
    secAuditDesc: "Todo inicio de sesión, intento fallido y cambio de usuarios queda registrado con fecha e IP.",
    secBackup: "Respaldo automático + base redundante",
    secBackupDesc: "La base de datos se respalda automáticamente cada 6 horas y se replica en una base espejo de emergencia.",
    secRoles: "Control de acceso por roles",
    secRolesDesc: "Cada usuario solo puede ver y modificar lo que su rol permite (admin, gerente, supervisor, visualizador).",
    securityPanel: "Seguridad y Respaldos",
    securityPanelHint: "Estado del sistema anti-hackeo, respaldos automáticos y base de datos redundante.",
    lastBackup: "Último respaldo",
    nextBackupEvery: "Respaldo automático cada {h} horas",
    runBackup: "Respaldar ahora",
    backupRunning: "Respaldando...",
    backupDone: "Respaldo completado",
    restoreReplica: "Restaurar desde base redundante",
    restoreConfirm: "⚠ Esto sobrescribirá la base de datos actual con la copia redundante. ¿Continuar?",
    restoreDone: "Base de datos restaurada desde la réplica",
    replicaDb: "Base redundante (espejo)",
    auditLogTitle: "Registro de auditoría",
    failedLogins24h: "Intentos fallidos (24h)",
    auditEvents: "Eventos auditados",
    noBackups: "Sin respaldos aún",
    backupFiles: "Archivos de respaldo",
    docsCount: "documentos",
    collectionsCount: "colecciones",
    eventCol: "Evento", actorCol: "Actor", ipCol: "IP", detailCol: "Detalle", whenCol: "Fecha",
    project: "Proyecto", generalArea: "Área general", noTasks: "Sin tareas registradas. Cree la primera tarea del cronograma.",
    noData: "Sin registros", confirmDelete: "¿Eliminar este registro?", today: "Hoy",
    invalidCredentials: "Credenciales inválidas", loading: "Cargando...",
    reportedBy: "Reportado por", spent: "Ejecutado", remaining: "Restante",
    perMillionHours: "por millón de horas-hombre",
    criticalPath: "Ruta Crítica", manHours: "Horas-Hombre del Período", update: "Actualizar",
    downloadTemplate: "Descargar Plantilla", importExcel: "Importar Excel", importedTasks: "tareas importadas",
    export: "Exportar", sCurve: "Curva S", settings: "Ajustes", companyLogo: "Logo de la Empresa",
    uploadLogo: "Subir Logo", removeLogo: "Quitar Logo", logoHint: "PNG o JPG, máximo 2MB. Aparecerá en la barra lateral y en los reportes PDF.",
    noLogo: "Sin logo cargado",
    installApp: "Instalar App", installOnIos: "Instalar en iPhone/iPad",
    iosInstallHint: "Para instalar UG Managment by OOMINING en tu dispositivo iOS, sigue estos pasos:",
    iosStep1: "Toca el botón Compartir en la barra de Safari.",
    iosStep2: "Desplázate y elige “Agregar a Pantalla de Inicio”.",
    iosStep3: "Confirma con “Agregar”. La app quedará disponible como ícono.",
    installUnavailable: "La instalación aún no está disponible en este navegador. Vuelve a intentarlo en unos segundos.",
    installSuccess: "¡UG Managment by OOMINING se instaló correctamente!",
    offlineMode: "Sin conexión", backOnline: "Conexión restablecida", wentOffline: "Sin conexión — datos cacheados disponibles",
    pendingChanges: "pendientes", pendingChangesHint: "Cambios guardados localmente. Toca para sincronizar ahora.",
    changesSynced: "cambios sincronizados", changesFailed: "cambios no pudieron sincronizarse",
    reload: "Recargar", syncPartial: "Sincronización parcial — aún hay cambios pendientes", nothingToSync: "No hay cambios pendientes",
    failedChanges: "fallidos", failedChangesHint: "Cambios rechazados por el servidor. Toca para revisar.",
    openSyncQueue: "Ver cola de sincronización",
    syncQueueTitle: "Cola de sincronización offline",
    syncQueueDesc: "Cambios guardados localmente cuando no había conexión o cuando el servidor los rechazó.",
    pending: "Pendientes", failed: "Fallidos", retry: "Reintentar", discard: "Descartar",
    retryAll: "Reintentar todo", clearFailed: "Borrar fallidos", attempts: "Intentos", review: "Revisar",
    confirmDeleteChange: "¿Descartar este cambio? Los datos se perderán.",
    confirmClearFailed: "¿Borrar todos los cambios fallidos?",
    savedOffline: "Guardado localmente — se sincronizará al volver la conexión",
    photos: "Fotos", addPhoto: "Agregar Foto", noPhotos: "Aún no hay fotos. Suba imágenes del avance de obra, incidentes o inspecciones.",
    photosHint: "Máx. 12MB por foto (PNG, JPG, WEBP o HEIC). Se convierten a JPEG y se incluyen en el reporte completo.",
    photoUploaded: "Foto subida", caption: "Descripción (opcional)",
    photoDropzoneHint: "Arrastra imágenes aquí o haz click para subir varias a la vez",
    photoAutoCompress: "Se optimizan automáticamente en el navegador o servidor (HEIC del iPhone también soportado).",
    maxPhotosReached: "Máx. {max} fotos por proyecto. Solo {remaining} adicionales caben.",
    openPhoto: "Ver foto",
    shareCompletePdf: "Compartir PDF Completo", downloadCompletePdf: "Descargar PDF Completo",
    generating: "Generando…", shareFallback: "Compartir no disponible — el archivo se descargó.",
    colorScheme: "Combinación de Colores", colorSchemeHint: "Personaliza los colores de marca. Los cambios se ven en tiempo real; presiona Guardar para hacerlos permanentes.",
    presets: "Paletas rápidas", colorPrimary: "Primario", colorAccent: "Acento", colorSuccess: "Éxito", colorDanger: "Peligro",
    themeSaved: "Tema guardado", resetToDefault: "Restaurar", saving: "Guardando…",
    confirmDeleteProject: "¿Eliminar el proyecto \"{name}\"?\n\nSe borrarán TODAS sus tareas, costos, fotos y datos relacionados. Esta acción es irreversible.",
    projectDeleted: "Proyecto eliminado",
    orientPortrait: "Vertical", orientLandscape: "Horizontal",
    activitySummary: "Resumen de Actividades", summaryAsOf: "Al día de",
    delayed: "Retrasadas", atRisk: "En Riesgo", early: "Adelantadas", inProgress: "En Curso", completed: "Completadas",
    completedEarly: "Completadas Anticipadas",
    daysLate: "días de retraso", daysCarryover: "días de arrastre", daysAhead: "días de anticipación",
    blockedBy: "Bloqueada por", plannedEnd: "Fin planificado",
    noDelayed: "Sin actividades retrasadas.", noAtRisk: "Sin actividades en riesgo.", noEarly: "Aún no hay actividades completadas antes de lo planeado.",
    summaryText: "Resumen ejecutivo", expandDetail: "click para expandir",
    lastUpdate: "Último registro", progressReported: "Avance reportado",
    expectedToday: "Esperado hoy", reportedToday: "Reportado hoy", variance: "Desfase", elapsed: "Días transcurridos", days: "días",
    scurveStatus_behind: "Atrasado", scurveStatus_ahead: "Adelantado", scurveStatus_on_track: "En Curso",
    scurveHintBehind: "El avance reportado está {v}% por debajo del esperado a la fecha. Revisar tareas retrasadas y ajustar recursos.",
    scurveHintAhead: "El avance reportado supera al esperado por {v}%. El proyecto va adelantado — buen desempeño.",
    scurveHintOnTrack: "El avance reportado está dentro de ±3% del esperado a la fecha. El proyecto avanza según lo planeado.",
    resourcesCatalog: "Recursos", resourcesHint: "Catálogo maestro de recursos (mano de obra, equipos, materiales, explosivos, servicios).",
    newResource: "Nuevo Recurso", editResource: "Editar Recurso", noResources: "No hay recursos registrados.",
    unitCost: "Costo Unitario", unit: "Unidad", quantity: "Cantidad", note: "Nota",
    res_labor: "Mano de Obra", res_equipment: "Equipo", res_material: "Material", res_explosive: "Explosivo", res_service: "Servicio", res_other: "Otro",
    taskTemplates: "Plantillas de Tarea", templatesHint: "Tareas prediseñadas con sus recursos típicos para reutilizarlas en proyectos.",
    newTemplate: "Nueva Plantilla", editTemplate: "Editar Plantilla", noTemplates: "No hay plantillas registradas.",
    durationDays: "Duración (días)", resourcesNeeded: "Recursos necesarios", addResource: "Añadir recurso",
    noResourcesInTemplate: "Esta plantilla aún no tiene recursos.",
    description: "Descripción", type: "Tipo",

    // Login tutorial modal
    tutorialOpen: "¿Cómo usar UG Managment by OOMINING?",
    tutorialTitle: "Guía rápida de UG Managment by OOMINING",
    tutorialSubtitle: "Explora cada módulo del sistema. Toca una sección para expandirla.",
    tutorialFooter: "Puedes reabrir esta guía cuando quieras desde la pantalla de acceso.",
    tutorialClose: "Entendido",
    tutDashboardTitle: "Panel de Control",
    tutDashboardSub: "KPIs generales de tu cartera de proyectos.",
    tutDashboardBullets: [
      "Ve de un vistazo proyectos activos, presupuesto total y costo real ejecutado.",
      "Sigue el avance promedio y los incidentes abiertos de seguridad.",
      "Consulta índices de Frecuencia (IF) y Severidad (IS) del período.",
      "Compara Presupuesto vs Real por proyecto y explora la cartera desde las tarjetas."
    ],
    tutProjectsTitle: "Proyectos",
    tutProjectsSub: "Crea, edita y da de baja proyectos.",
    tutProjectsBullets: [
      "Nuevo Proyecto: define código, área/nivel, presupuesto y fechas de inicio y fin.",
      "Asigna un responsable y estado (Planificación, Activo, En Pausa, Completado).",
      "Elimina un proyecto en cascada: se borran tareas, costos y fotos asociadas.",
      "Entra al detalle para gestionar tareas, costos, fotos y descargar reportes."
    ],
    tutGanttTitle: "Cronograma (Gantt)",
    tutGanttSub: "Tareas, fases, dependencias e importación desde Excel.",
    tutGanttBullets: [
      "Agrega tareas con fase, responsable, inicio, fin y % de avance.",
      "Define dependencias para calcular la ruta crítica y detectar retrasos por arrastre.",
      "Agrupa por fase con color propio; usa nombres personalizados si tu obra lo requiere.",
      "Descarga la plantilla, llena en Excel e importa las tareas de un tiro.",
      "El resumen de actividades muestra Retrasadas, En Riesgo y Adelantadas al día de hoy."
    ],
    tutScurveTitle: "Curva S",
    tutScurveSub: "Avance esperado vs avance reportado.",
    tutScurveBullets: [
      "Se calcula automáticamente a partir de tareas y % reportados.",
      "El snapshot del día compara Esperado vs Reportado con % de desfase.",
      "Estado del proyecto: Atrasado, En Curso o Adelantado.",
      "Puedes exportar la curva S en PDF (horizontal o vertical) o en Excel."
    ],
    tutCostsTitle: "Costos",
    tutCostsSub: "Presupuesto, movimientos y variaciones por categoría.",
    tutCostsBullets: [
      "Registra movimientos Planificado y Real por categoría (mano de obra, equipos, materiales, explosivos, servicios).",
      "El resumen calcula variación por categoría y presupuesto restante.",
      "Usa el catálogo de Recursos para estandarizar costos unitarios.",
      "Exporta el reporte de costos en PDF o Excel para compartir con gerencia."
    ],
    tutSafetyTitle: "Seguridad",
    tutSafetySub: "Incidentes, inspecciones e indicadores.",
    tutSafetyBullets: [
      "Registra incidentes: Casi Accidente, Primeros Auxilios, Tratamiento Médico, Tiempo Perdido, Fatalidad.",
      "Lleva inspecciones con % de cumplimiento y hallazgos.",
      "Se calculan automáticamente IF y IS con base en horas-hombre del período.",
      "Consulta LTI, días perdidos y cumplimiento promedio en un solo panel.",
      "Exporta el reporte completo de seguridad a PDF o Excel."
    ],
    tutPhotosTitle: "Fotos del Proyecto",
    tutPhotosSub: "Anexo fotográfico de avance de obra.",
    tutPhotosBullets: [
      "Sube fotos (PNG, JPG o WEBP, máx 5 MB) directamente desde tu celular.",
      "Añade una descripción por foto para contextualizarla.",
      "Se incluyen automáticamente en el PDF Completo.",
      "Se comprimen al exportar para que el PDF sea liviano y rápido de compartir."
    ],
    tutReportsTitle: "Reportes PDF / Excel",
    tutReportsSub: "Gantt, Curva S, Costos, Seguridad y PDF Completo.",
    tutReportsBullets: [
      "Exporta cada módulo por separado, o el PDF Completo con todo consolidado.",
      "Elige orientación Horizontal (recomendada para Gantt) o Vertical.",
      "El PDF Completo incluye portada, resumen de actividades, Gantt, Curva S, costos y anexo fotográfico.",
      "En dispositivos móviles usa Compartir para enviar por WhatsApp o correo."
    ],
    tutOfflineTitle: "Modo Sin Conexión (PWA)",
    tutOfflineSub: "Sigue trabajando bajo tierra sin internet.",
    tutOfflineBullets: [
      "Instala UG Managment by OOMINING en el celular desde el menú del navegador (Añadir a Pantalla).",
      "Sin señal, la app funciona con datos cacheados.",
      "Los cambios se guardan en una cola local y se sincronizan solos al recuperar conexión.",
      "Un aviso en la parte superior muestra los cambios pendientes por sincronizar."
    ],
    tutSettingsTitle: "Ajustes y Catálogos",
    tutSettingsSub: "Marca, tema y datos maestros.",
    tutSettingsBullets: [
      "Sube el logo de tu empresa (aparece en la barra lateral y en los PDFs).",
      "Personaliza los colores de marca (Primario, Acento, Éxito, Peligro) o usa una paleta rápida.",
      "Configura Recursos maestros (con costo unitario y unidad) y Plantillas de Tarea.",
      "Ajusta las horas-hombre del período para el cálculo de IF/IS."
    ],
    tutUsersTitle: "Usuarios y Roles",
    tutUsersSub: "Control de acceso por rol.",
    tutUsersBullets: [
      "Administrador: acceso total, gestiona usuarios y catálogos.",
      "Gerente: crea proyectos, tareas, costos, seguridad y reportes.",
      "Supervisor: registra avances, incidentes e inspecciones.",
      "Visualizador: solo lectura de dashboards y reportes."
    ],

    // Notifications
    notifications: "Notificaciones",
    noNotifications: "Sin notificaciones. Cuando ocurra algo relevante en tus proyectos aparecerá aquí.",
    markAllRead: "Marcar todas como leídas",

    // Share links
    shareLinkButton: "Link para compartir",
    shareLinkTitle: "Compartir informe por link público",
    shareLinkSubtitle: "Genera un link con vigencia limitada del proyecto {code}. Quien lo reciba podrá descargar el PDF Completo sin necesidad de iniciar sesión.",
    shareLinkGenerate: "Nuevo link",
    shareLinkTtl: "Vigencia",
    shareLinkOrient: "Orientación del PDF",
    shareLinkCreate: "Generar link",
    shareLinkCreated: "Link generado y copiado a la lista",
    shareLinkCopied: "Link copiado al portapapeles",
    shareLinkCopyManual: "Copia este link manualmente:",
    shareLinkRevokeConfirm: "¿Revocar este link? Dejará de funcionar de inmediato.",
    shareLinkRevoked: "Link revocado",
    shareLinkRevokedTag: "Revocado",
    shareLinkExpiredTag: "Vencido",
    shareLinkExpires: "Vence:",
    shareLinkHits: "{n} accesos",
    shareLinkActive: "Links del proyecto",
    shareLinkNone: "Aún no has generado links para este proyecto.",
    shareTtl1h: "1 hora",
    shareTtl24h: "24 horas",
    shareTtl7d: "7 días",
    copy: "Copiar",
    copied: "Copiado",

    // Task resources & detail
    assignedResources: "Recursos asignados",
    noResourcesAssigned: "Sin recursos asignados a esta tarea.",
    addResource: "Añadir recurso",
    selectResource: "Selecciona del catálogo…",
    customResource: "Personalizado…",
    resourceName: "Nombre del recurso",
    qty: "Cant.",
    unit: "Unidad",
    resourceNote: "Nota",
    duration: "Duración",
    days: "días",
    dependencies: "Dependencias",
    blocks: "Bloquea a",
    progressHistory: "Historial de avances",
    noProgressHistory: "Aún no se registran actualizaciones de avance.",
    loading: "Cargando…",
    taskStatusDelayed: "Retrasada",
    taskStatusAtRisk: "En riesgo",
    taskStatusEarly: "Adelantada",
    taskStatusOnTrack: "En curso",
    progressEvents: "Actualizaciones registradas",
    noProgressEvents: "Sin actualizaciones en esta fecha",
    myWork: "Mi Trabajo",
    myTasks: "Mis Tareas",
    myActions: "Mis Acciones HSE",
    myCerts: "Mis Certificados",
    noMyTasks: "No tienes tareas asignadas actualmente.",
    noMyActions: "No tienes acciones HSE pendientes.",
    noMyCerts: "Todos tus certificados están vigentes.",
    myWorkHint: "Vista consolidada de tu carga de trabajo actual: tareas asignadas, acciones HSE pendientes y certificados por vencer.",
    overdue: "Vencida",
    dueIn: "Vence en",
    daysLeft: "días",
    priorityHigh: "Alta", priorityMedium: "Media", priorityLow: "Baja",
    hrProfile: "Ficha del colaborador",
    notInHR: "Aún no tienes ficha en Recurso Humano. Pide a un administrador que te vincule para ver tus certificados.",
    verifyPdfLink: "Verificar autenticidad de un PDF SGSSO",
    verifyPdfHint: "Auditores y clientes pueden validar cualquier reporte firmado sin necesidad de cuenta.",
    verifyPdfTitle: "Verificador de PDFs",
    verifyPdfHeading: "Verifica la autenticidad de un reporte SGSSO",
    verifyPdfBlurb: "Sube el archivo PDF y extraeremos su firma electrónica SHA-256. Si el hash coincide con un reporte emitido por este sistema, mostraremos los datos de origen. Sin necesidad de iniciar sesión.",
    verifyDropHere: "Arrastra tu PDF aquí o haz clic para seleccionarlo",
    verifyClickToBrowse: "Máx. 15 MB · sólo archivos .pdf",
    verifyValidating: "Validando firma electrónica…",
    verifyOkBadge: "DOCUMENTO AUTÉNTICO",
    verifyNoSigBadge: "Sin firma electrónica",
    verifyNotFoundBadge: "FIRMA NO ENCONTRADA",
    verifyKind: "Módulo",
    verifyGeneratedAt: "Generado (UTC)",
    verifyGeneratedBy: "Firmado por",
    verifyRecords: "Registros incluidos",
    verifyFrom: "Desde",
    verifyTo: "Hasta",
    verifyCompany: "Empresa",
    verifyContract: "Contrato",
    verifyFoundInPdf: "hallado en el PDF",
    verifyErrNotPdf: "El archivo debe ser un PDF.",
    verifyErrGeneric: "No se pudo verificar el PDF. Intenta nuevamente.",
    verifyHow1: "La firma SHA-256 se genera al emitir el reporte y se almacena en los metadatos del PDF.",
    verifyHow2: "Cualquier alteración del contenido invalida la firma y el reporte deja de coincidir.",
    verifyHow3: "El verificador es público y sin autenticación — límite de 10 verificaciones cada 5 minutos por IP.",
    // Change Password (forced on must_change_password)
    cpTitle: "Cambia tu contraseña temporal",
    cpBanner: "Tu cuenta fue creada con una contraseña temporal. Antes de continuar, elige una contraseña propia que sólo tú conozcas.",
    cpCurrent: "Contraseña temporal",
    cpNew: "Nueva contraseña",
    cpConfirm: "Confirmar nueva contraseña",
    cpHint: "Mínimo 8 caracteres, incluye mayúscula, minúscula y número.",
    cpSubmit: "Guardar y continuar",
    cpLogout: "Cerrar sesión",
    cpSuccess: "Contraseña actualizada. ¡Bienvenido!",
    cpMismatch: "Las contraseñas no coinciden.",
    cpTooShort: "La contraseña nueva debe tener al menos 8 caracteres.",
    // Forgot / Reset password (public)
    forgotPasswordLink: "¿Olvidaste tu contraseña?",
    fpTitle: "Restablecer contraseña",
    fpBlurb: "Ingresa el correo de tu cuenta y te enviaremos un enlace para elegir una nueva contraseña. El enlace expira en 30 minutos.",
    fpSubmit: "Enviar enlace",
    fpBackLogin: "Volver a iniciar sesión",
    fpSentTitle: "Revisa tu correo",
    fpSentBody: "Si el correo pertenece a una cuenta activa, recibirás un enlace para restablecer tu contraseña.",
    fpSentSpam: "Si no lo ves en unos minutos, revisa la bandeja de spam.",
    rpTitle: "Nueva contraseña",
    rpBlurb: "Elige una contraseña que sólo tú conozcas. Aplica la misma política que en el resto del sistema.",
    rpSubmit: "Guardar y continuar",
    rpSuccess: "Contraseña restablecida",
    rpSuccessBody: "Ya puedes iniciar sesión con tu nueva contraseña.",
    rpGoLogin: "Ir a iniciar sesión",
    rpNoToken: "Enlace inválido o incompleto",
    rpRequestNew: "Solicita un nuevo enlace",
    // Estado de seguridad (panel público en /verify)
    secStatusTitle: "Estado de Seguridad de la Plataforma",
    secStatusBlurb: "Controles de seguridad activos en esta implementación. Auditados por el equipo de ingeniería y validados con pruebas automatizadas. Cualquier auditor externo puede solicitar el detalle técnico bajo NDA.",
    secStatusFooter: "Última auditoría interna · Feb 2026",
    secBadgeBcrypt: "Contraseñas con bcrypt",
    secBadgeBcryptSub: "Hash + salt aleatorio · nunca en texto plano · política mín. 8 chars con mayúscula/minúscula/número.",
    secBadgeJwt: "Sesiones JWT httpOnly",
    secBadgeJwtSub: "Cookies con secure + samesite=none · inaccesibles desde JS · TTL 7 días.",
    secBadgeBrute: "Anti brute-force",
    secBadgeBruteSub: "5 intentos fallidos → bloqueo 15 min · rate-limit distribuido por IP.",
    secBadgeAudit: "Registro de auditoría",
    secBadgeAuditSub: "Todos los eventos críticos (login/backup/permisos) con retención 90 días.",
    secBadgeBackup: "Backups automáticos",
    secBadgeBackupSub: "Respaldo cada 6h + base de datos redundante en espejo para recuperación express.",
    secBadgeSha: "Firma SHA-256 en PDFs",
    secBadgeShaSub: "Cada reporte SGSSO firmado electrónicamente y verificable en este portal.",
    secBadgeCors: "CORS restringido",
    secBadgeCorsSub: "Solo dominios autorizados pueden hacer peticiones con credenciales. Wildcard bloqueado.",
    secBadgeOffline: "Modo offline seguro",
    secBadgeOfflineSub: "Sesión cacheada por 7 días en IndexedDB · nunca se guarda contraseña ni token en claro.",
    offlineBanner: "MODO OFFLINE",
    offlineBannerHint: "Los datos que captures se guardan localmente y se sincronizarán al recuperar señal",
    offlineDetected: "Sin conexión detectada",
    cachedSessionAvailable: "Encontramos una sesión activa en este dispositivo. Puedes continuar trabajando offline; tus cambios se sincronizarán cuando vuelvas a tener señal.",
    cachedSessionExpires: "La sesión offline vence",
    continueOffline: "Continuar sesión offline",
    resumedOfflineToast: "Sesión offline reanudada. Recuerda sincronizar cuando vuelvas a tener señal.",
    shiftOwnerEmpty: "Sin turno",
    shiftOwnerChipEmptyTitle: "Asignar operador del turno para este dispositivo",
    shiftOwnerChipActiveTitle: "Operador actual del turno · click para cambiar",
    shiftOwnerDialogTitle: "Operador del turno",
    shiftOwnerDialogHint: "Selecciona qué colaborador está físicamente usando este dispositivo. Cada observación, charla o investigación capturada quedará atribuida a esta persona — útil cuando la tablet se pasa de mano en el socavón.",
    shiftOwnerSearchPlaceholder: "Buscar por nombre, cargo, cuadrilla o DNI…",
    shiftOwnerNoMatches: "Sin coincidencias en el directorio activo.",
    shiftOwnerAssigned: "{name} asignado al turno de este dispositivo",
    shiftOwnerCleared: "Turno finalizado",
    shiftOwnerStartedAt: "Turno iniciado",
    shiftOwnerEndShift: "Finalizar turno",
    shiftOwnerTag: "Turno",
    finAnalysisTitle: "Análisis Financiero",
    finAnalysisSubtitle: "Rentabilidad por ML · Flujo de caja · Retorno de equipos",
    hrReqSubtitle: "Solicitudes de vacaciones · permisos · médico",
    hrReqNoPending: "Sin solicitudes pendientes",
    hrReqPendingN: "pendiente(s)",
    hrReqStatusFilter: "Estado",
    hrReqStatusPending: "Pendientes",
    hrReqStatusApproved: "Aprobadas",
    hrReqStatusRejected: "Rechazadas",
    hrReqStatusAll: "Todas",
    hrReqExportBtn: "Exportar Excel",
    hrReqExportedToast: "Excel de solicitudes descargado",
    hrReqLoading: "Cargando solicitudes…",
    hrReqEmptyPending: "No hay solicitudes pendientes de revisar.",
    hrReqEmptyOther: "Sin solicitudes en este estado.",
    hrReqColEmployee: "Colaborador",
    hrReqColType: "Tipo",
    hrReqColRange: "Rango",
    hrReqColReason: "Motivo",
    hrReqColRequested: "Solicitado",
    hrReqColStatus: "Estado",
    hrReqColActions: "Acciones",
    hrReqBtnApprove: "Aprobar",
    hrReqBtnReject: "Rechazar",
    hrReqApproveDialogTitle: "Aprobar solicitud",
    hrReqRejectDialogTitle: "Rechazar solicitud",
    hrReqReviewNote: "Nota de revisión (opcional)",
    hrReqPlaceholderApprove: "Aprobado por gerencia",
    hrReqPlaceholderReject: "Motivo del rechazo",
    hrReqAutoDaysInfo: "Se marcarán automáticamente los días del rango como {type} en la asistencia del colaborador.",
    hrReqCancel: "Cancelar",
    hrReqProcessing: "Procesando…",
    hrReqApprovedToast: "Aprobada",
    hrReqRejectedToast: "Solicitud rechazada",
    hrReqDaysMarked: "día(s) marcados en asistencia",
    hrReqEmailSent: "Notificación enviada al colaborador por correo",
    hrReqEmailNoAddress: "El colaborador no tiene correo vinculado — notificación no enviada",
    hrReqEmailNoConfig: "Resend no configurado — sin notificación por correo",
    hrReqNotePrefix: "Nota",
    hrReqReviewedByPrefix: "Por",
    hrReqTypeVacation: "Vacaciones",
    hrReqTypePermit: "Permiso",
    hrReqTypeMedical: "Médico",
    hrReqAgo: "hace",
    hrReqMinShort: "min",
    hrReqHourShort: "h",
    hrReqDayShort: "d",
    hrTabKpis: "KPIs", hrTabPayroll: "Nómina", hrTabSchedule: "Calendario", hrTabAttendance: "Asistencia",
    hrTabRequests: "Solicitudes", hrTabCerts: "Certificados", hrTabOrgchart: "Organigrama",
    hrTabVacancies: "Vacantes", hrTabTalent: "Banco de Talento", hrTabReimb: "Reembolsos",
    hrTabSignatures: "Bitácora firmas",
    hrTabWhatsApp: "WhatsApp · Twilio",
    hrPdfGeneral: "Reporte General RRHH", hrPdfPayroll: "Nómina", hrPdfCalendar: "Calendario / Asistencia",
    hrPdfCerts: "Certificados", hrPdfVacancies: "Vacantes", hrPdfReimb: "Reembolsos",
    hrPdfGenerating: "Generando PDF…",
    hrSubtitle: "Gestión de personal · Cuadrillas · Calendario · Asistencia",
    hrQrPortal: "QR Portal", hrCareersPortal: "Portal de empleo",
    hrCareersLinkCopied: "Link del portal de empleo copiado",
    hse: "SGSSO",
    hseSubtitle: "Sistema de Gestión de Seguridad y Salud Ocupacional",
    hr: "Recurso Humano",
    finAnalysis: "Análisis Financiero",
    maintenance: "Mantenimiento Diésel",
    camp: "Campamento",
    campSubtitle: "Habitaciones · Ocupantes · Lavandería · Agua",
    campTabLayout: "Layout", campTabRooms: "Habitaciones", campTabLaundry: "Lavandería", campTabWater: "Agua",
    campNoRooms: "Aún no hay habitaciones. Crea la primera para comenzar.",
    campNewRoom: "Nueva habitación", campEditRoom: "Editar habitación",
    campRoomNumber: "Número", campRoomBlock: "Bloque / Módulo", campRoomFloor: "Piso",
    campRoomCapacity: "Capacidad (camas)", campRoomNotes: "Notas",
    campRoomWidth: "Ancho (celdas)", campRoomHeight: "Alto (celdas)",
    campAssignOccupant: "Asignar ocupante", campReleaseOccupant: "Liberar",
    campSelectEmployee: "Selecciona colaborador…", campBedLabel: "Cama / litera",
    campEmpty: "Habitación vacía", campFull: "Habitación llena",
    campOccupancy: "Ocupación", campBeds: "camas",
    campRooms: "Habitaciones", campOccupants: "Ocupantes", campBlocks: "Bloques",
    campLaundryHint: "Rol de lavandería semanal. Asigna un responsable por día para cada bloque; el sistema arrastra los ocupantes automáticamente.",
    campLaundryDay: "Día", campLaundryResponsible: "Responsable", campLaundryWeekOf: "Semana del",
    campWaterTitle: "Cálculo de consumo de agua",
    campWaterHint: "Basado en el personal en sitio (ocupantes del campamento). El estándar por defecto es 150 L/persona/día (campamento minero doméstico).",
    campWaterLitersPerson: "Litros por persona/día", campWaterDays: "Días del período",
    campWaterHeadcount: "Personal en sitio (auto)",
    campWaterDaily: "Consumo diario", campWaterPeriod: "Consumo del período",
    campWaterStandards: "Estándares de referencia",
    campWaterCompute: "Calcular", campWaterFormula: "Fórmula",
    campSourceCamp: "Ocupantes del campamento", campSourceHr: "Activos en Nómina", campSourceManual: "Manual",
    dayShort0: "Lun", dayShort1: "Mar", dayShort2: "Mié", dayShort3: "Jue", dayShort4: "Vie", dayShort5: "Sáb", dayShort6: "Dom",
    operations: "Operaciones", bitacora: "Bitácora", inventory: "Inventario", finance: "Finanzas",
    pdfReports: "Reportes PDF", fieldReport: "Reporte de campo",
    menu: "Menú", hide: "Ocultar", hideMenu: "Ocultar menú", expandMenu: "Expandir menú",
    hseTabKpis: "KPIs", hseTabTargets: "Objetivos", hseTabIper: "IPER-C", hseTabBowtie: "Bow-Tie", hseTabDaily: "Reporte Diario", hseFieldReport: "Reporte de campo",
    hseTabJsa: "AST", hseTabPermits: "Permisos", hseTabObservations: "OCAS",
    hseTabToolbox: "Charlas 5-min", hseTabInvestigations: "Investigaciones",
    hseTabActions: "Acciones", hseTabNormAudit: "Auditoría Normativa", hseTabMedical: "Pruebas Médicas", hseTabEpp: "Entrega de EPP", hseTabSupervisor: "Supervisor de primera línea", hseTabDriverLicenses: "Licencias de manejo", hseTabLegacy: "Incidentes / Inspecciones",
    semaforoHealthy: "SALUDABLE", semaforoAmber: "ALERTA ÁMBAR", semaforoRed: "ALERTA ROJA",
    obsCountSuffix: "observaciones",
    weeklySenderUnverified: "Resend usa el remitente sandbox 'onboarding@resend.dev' — solo envía a tu propia cuenta. Verifica un dominio en resend.com/domains y actualiza SENDER_EMAIL en el backend.",
    shiftOwnerReportBtn: "Descargar Excel del turno",
    shiftOwnerReportDownloaded: "Reporte de turno descargado",
    usersBulkFromHr: "Generar cuentas desde Nómina",
    usersBulkTitle: "Generar cuentas de usuario para toda la nómina",
    usersBulkHint: "Se creará una cuenta para cada colaborador activo que aún no tenga usuario. Se te devolverá un listado con las contraseñas temporales para imprimir / distribuir. Puedes hacer esto tantas veces necesites — solo procesa colaboradores nuevos.",
    usersBulkConfirm: "Generar {count} cuentas",
    usersBulkNoCandidates: "Todos los colaboradores activos ya tienen cuenta",
    usersBulkCreated: "{count} cuentas creadas · descarga el CSV con las credenciales",
    usersBulkDownloadCsv: "Descargar credenciales (CSV)",
    dashboardMyStats: "Mi actividad esta semana",
    dashboardTeamStats: "Actividad de mi equipo",
    kpiMetersYtd: "Metros ejecutados (YTD)",
    kpiVsBudget: "vs Budget",
    dashOpShifts: "Mis turnos", dashOpShiftsHint: "capturados esta semana",
    dashOpHours: "Horas trabajadas", dashThisWeek: "esta semana",
    dashOpObservations: "Observaciones que reporté", dashOpObservationsHint: "aporte a seguridad",
    dashOpToolbox: "Charlas 5-min presenciadas", dashOpToolboxHint: "esta semana",
    dashOpRecentShifts: "Mis últimos turnos",
    dashSupTeamShifts: "Turnos del equipo", dashSupOpenObs: "Observaciones abiertas",
    dashSupOpenObsHint: "requieren tu revisión", dashSupPendingHr: "Solicitudes de RRHH",
    dashSupPendingHrHint: "esperan aprobación", dashSupCompliance: "Cumplimiento",
    dashSupTeamActivity: "Actividad del equipo (7 días)",
    "role.admin": "Administrador", "role.owner": "Dueño", "role.manager": "Gerente",
    "role.director": "Director", "role.jefatura": "Jefatura", "role.supervisor": "Supervisor",
    "role.operador": "Operador", "role.mecanico": "Mecánico", "role.perforista": "Perforista",
    "role.almacenista": "Almacenista", "role.viewer": "Consulta",
    operator: "Operador", equipment: "Equipo", hours: "Horas",
    hrReqTypeVacation: "Vacaciones", hrReqTypePermit: "Permiso", hrReqTypeMedical: "Médico",
    dashInlineHrTitle: "Aprobaciones pendientes · resuelve desde aquí",
    dashInlineObsTitle: "Observaciones abiertas · cierra las urgentes",
    dashInlineQuickClosed: "Cerrada desde el panel de control",
    obsOpenSuffix: "abiertas",
    obsReportBtn: "Reportar observación",
    obsNewTitle: "Nueva observación de seguridad",
    obsEditTitle: "Editar observación",
    obsFieldType: "Tipo",
    obsFieldArea: "Área / Nivel",
    obsFieldDesc: "Descripción",
    obsFieldAction: "Acción inmediata tomada",
    obsFieldSeverity: "Severidad",
    obsFieldPhotos: "Fotos (opcional · hasta 6)",
    obsKindUnsafeAct: "Acto inseguro",
    obsKindUnsafeCondition: "Condición insegura",
    obsKindPositive: "Observación positiva",
    obsSevLow: "Baja",
    obsSevMedium: "Media",
    obsSevHigh: "Alta",
    obsPlaceholderArea: "Ej. Galería 850",
    obsPlaceholderDesc: "¿Qué observaste?",
    obsPlaceholderAction: "Retiré personal, avisé al supervisor…",
    obsSubmit: "Enviar",
    obsUpdateSubmit: "Guardar cambios",
    obsSavedToast: "Observación registrada",
    obsUpdatedToast: "Observación actualizada",
    obsClosedToast: "Cerrada",
    obsClosedBadge: "Cerrada",
    obsActionShort: "Acción",
    obsResolutionLabel: "Resolución",
    obsEdit: "Editar",
    obsClose: "Cerrar",
    obsNoObservations: "Sin observaciones",
    obsDeleteConfirm: "¿Eliminar esta observación?",
    obsResolveTitle: "Cerrar observación",
    obsResolveNote: "Nota de resolución",
    obsResolveConfirm: "Confirmar cierre",
    obsFieldResponsible: "Responsable de seguimiento",
    obsResponsibleHint: "Al asignar, se crea automáticamente una acción correctiva vinculada",
    obsLinkedActionBadge: "Acción vinculada",
    obsOcasFullName: "OCAS · Observación de Condiciones y Actos Sub estándar",
  },
  en: {
    appName: "UG Managment by OOMINING",
    tagline: "Mining Project Management",
    login: "Sign In", email: "Email", password: "Password", signIn: "Sign In", logout: "Log out",
    dashboard: "Dashboard", projects: "Projects", safety: "Safety", users: "Users", schedule: "Schedule",
    costs: "Costs", overview: "Overview", tasks: "Tasks",
    activeProjects: "Active Projects", totalBudget: "Total Budget", actualCost: "Actual Cost", avgProgress: "Avg Progress",
    openIncidents: "Open Incidents", daysLost: "Days Lost", frequencyRate: "Frequency Rate", severityRate: "Severity Rate",
    budgetVsActual: "Budget vs Actual", incidentsByType: "Incidents by Type", projectPortfolio: "Project Portfolio",
    newProject: "New Project", name: "Name", code: "Code", status: "Status", startDate: "Start Date", endDate: "End Date",
    budget: "Budget", manager: "Manager", area: "Area / Level", description: "Description", progress: "Progress",
    planning: "Planning", active: "Active", on_hold: "On Hold", completed: "Completed",
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", actions: "Actions", create: "Create",
    newTask: "New Task", phase: "Phase", assignee: "Assignee", dependsOn: "Depends on", none: "None",
    development: "Development", drilling: "Drilling & Blasting", hauling: "Hauling", ground_support: "Ground Support",
    services: "Services", ventilation: "Ventilation", other: "Other",
    newCost: "New Cost", category: "Category", amount: "Amount", date: "Date", type: "Type",
    labor: "Labor", equipment: "Equipment", materials: "Materials", explosives: "Explosives",
    planned: "Planned", actual: "Actual", total: "Total", variance: "Variance",
    incidents: "Incidents", inspections: "Inspections", newIncident: "New Incident", newInspection: "New Inspection",
    near_miss: "Near Miss", first_aid: "First Aid", medical_treatment: "Medical Treatment",
    lost_time: "Lost Time", fatality: "Fatality", severity: "Severity",
    open: "Open", investigating: "Investigating", closed: "Closed",
    inspector: "Inspector", findings: "Findings", compliance: "Compliance", avgCompliance: "Avg Compliance",
    totalIncidents: "Total Incidents", ltiIncidents: "Lost Time Incidents",
    newUser: "New User", role: "Role", admin: "Administrator", supervisor: "Supervisor", viewer: "Viewer",
    managerRole: "Manager", createdAt: "Created",
    jefaturaRole: "Head", almacenistaRole: "Warehouse Keeper", mecanicoRole: "Mechanic", operadorRole: "Operator",
    userSourceManual: "Manual", userSourceFromHR: "From Payroll",
    selectEmployee: "Select an employee…", noHRCandidates: "No payroll employees without a user account",
    welcomeBack: "Welcome back", loginSubtitle: "Integrated management system for underground mining",
    secTitle: "Anti-Hacking Security System",
    secSubtitle: "Your information is protected with enterprise-grade security",
    secEncryption: "Passwords encrypted with bcrypt",
    secEncryptionDesc: "Passwords are stored with an irreversible hash; not even administrators can see them.",
    secTokens: "Sessions with signed JWT tokens",
    secTokensDesc: "Secure httpOnly cookies that prevent session theft by malicious scripts (anti-XSS).",
    secBruteForce: "Brute-force lockout",
    secBruteForceDesc: "After 5 failed attempts the account locks for 15 minutes and each IP has a global attempt limit.",
    secHeaders: "Browser HTTP shielding",
    secHeadersDesc: "Security headers (HSTS, anti-clickjacking, anti-sniffing) on every server response.",
    secAudit: "24/7 security auditing",
    secAuditDesc: "Every login, failed attempt and user change is recorded with timestamp and IP.",
    secBackup: "Automatic backups + redundant database",
    secBackupDesc: "The database is backed up automatically every 6 hours and mirrored to an emergency replica.",
    secRoles: "Role-based access control",
    secRolesDesc: "Each user can only view and modify what their role allows (admin, manager, supervisor, viewer).",
    securityPanel: "Security & Backups",
    securityPanelHint: "Anti-hacking system status, automatic backups and redundant database.",
    lastBackup: "Last backup",
    nextBackupEvery: "Automatic backup every {h} hours",
    runBackup: "Back up now",
    backupRunning: "Backing up...",
    backupDone: "Backup completed",
    restoreReplica: "Restore from redundant database",
    restoreConfirm: "⚠ This will overwrite the current database with the redundant copy. Continue?",
    restoreDone: "Database restored from replica",
    replicaDb: "Redundant database (mirror)",
    auditLogTitle: "Audit log",
    failedLogins24h: "Failed attempts (24h)",
    auditEvents: "Audited events",
    noBackups: "No backups yet",
    backupFiles: "Backup files",
    docsCount: "documents",
    collectionsCount: "collections",
    eventCol: "Event", actorCol: "Actor", ipCol: "IP", detailCol: "Detail", whenCol: "Date",
    project: "Project", generalArea: "General area", noTasks: "No tasks yet. Create the first schedule task.",
    noData: "No records", confirmDelete: "Delete this record?", today: "Today",
    invalidCredentials: "Invalid credentials", loading: "Loading...",
    reportedBy: "Reported by", spent: "Spent", remaining: "Remaining",
    perMillionHours: "per million man-hours",
    criticalPath: "Critical Path", manHours: "Period Man-Hours", update: "Update",
    downloadTemplate: "Download Template", importExcel: "Import Excel", importedTasks: "tasks imported",
    export: "Export", sCurve: "S-Curve", settings: "Settings", companyLogo: "Company Logo",
    uploadLogo: "Upload Logo", removeLogo: "Remove Logo", logoHint: "PNG or JPG, max 2MB. Shown in the sidebar and PDF reports.",
    noLogo: "No logo uploaded",
    installApp: "Install App", installOnIos: "Install on iPhone/iPad",
    iosInstallHint: "To install UG Managment by OOMINING on your iOS device, follow these steps:",
    iosStep1: "Tap the Share button in Safari's bar.",
    iosStep2: "Scroll and choose \"Add to Home Screen\".",
    iosStep3: "Confirm with \"Add\". The app will appear as an icon.",
    installUnavailable: "Install prompt not available yet in this browser. Try again in a few seconds.",
    installSuccess: "UG Managment by OOMINING installed successfully!",
    offlineMode: "Offline", backOnline: "Back online", wentOffline: "You are offline — cached data available",
    pendingChanges: "pending", pendingChangesHint: "Saved locally. Tap to sync now.",
    changesSynced: "changes synced", changesFailed: "changes failed to sync",
    reload: "Reload", syncPartial: "Partial sync — some changes still pending", nothingToSync: "Nothing to sync",
    failedChanges: "failed", failedChangesHint: "Changes rejected by the server. Tap to review.",
    openSyncQueue: "Open sync queue",
    syncQueueTitle: "Offline sync queue",
    syncQueueDesc: "Changes saved locally while offline or after the server rejected them.",
    pending: "Pending", failed: "Failed", retry: "Retry", discard: "Discard",
    retryAll: "Retry all", clearFailed: "Clear failed", attempts: "Attempts", review: "Review",
    confirmDeleteChange: "Discard this change? Data will be lost.",
    confirmClearFailed: "Clear all failed changes?",
    savedOffline: "Saved locally — will sync when back online",
    photos: "Photos", addPhoto: "Add Photo", noPhotos: "No photos yet. Upload site progress, incident or inspection images.",
    photosHint: "Max 12MB per photo (PNG, JPG, WEBP or HEIC). Auto-converted to JPEG and included in the complete report.",
    photoUploaded: "Photo uploaded", caption: "Caption (optional)",
    photoDropzoneHint: "Drag images here or click to upload multiple at once",
    photoAutoCompress: "Auto-optimized in browser or server (iPhone HEIC also supported).",
    maxPhotosReached: "Max {max} photos per project. Only {remaining} extra fit.",
    openPhoto: "Open photo",
    shareCompletePdf: "Share Complete PDF", downloadCompletePdf: "Download Complete PDF",
    generating: "Generating…", shareFallback: "Share not available — file downloaded instead.",
    colorScheme: "Color Scheme", colorSchemeHint: "Customize the brand colors. Changes preview live; press Save to make them permanent.",
    presets: "Presets", colorPrimary: "Primary", colorAccent: "Accent", colorSuccess: "Success", colorDanger: "Danger",
    themeSaved: "Theme saved", resetToDefault: "Reset", saving: "Saving…",
    weeklyReport: "Weekly Executive Report",
    weeklyReportHint: "Automated weekly email with top KPIs (progress, budget vs actual, EBITDA, cashflow) with red/yellow/green traffic lights. Sent via Resend to configured recipients in their preferred language.",
    enableWeekly: "Enable automatic sending",
    weekDay: "Day of week", sendHour: "Hour to send (UTC)",
    dayMon: "Monday", dayTue: "Tuesday", dayWed: "Wednesday", dayThu: "Thursday", dayFri: "Friday", daySat: "Saturday", daySun: "Sunday",
    recipients: "Recipients", addRecipient: "Add recipient",
    recipientEmail: "Email", recipientName: "Name", recipientLang: "Language",
    langEs: "Español", langEn: "English",
    previewEmail: "Preview", sendNow: "Send now",
    weeklyHistory: "Send history",
    lastSent: "Last sent", sentOk: "Sent OK", sentFail: "Failed",
    triggeredBy: "Triggered by", weekIso: "Week",
    noHistoryYet: "No report has been sent yet.",
    sendingNow: "Sending…", sentSuccess: "Report sent to {count} recipients",
    sentPartial: "{ok} sent, {fail} failed",
    sentNoConfig: "No recipients configured",
    kpiOnTarget: "On target", kpiWarning: "Attention", kpiOffTarget: "Off target",
    confirmDeleteProject: "Delete project \"{name}\"?\n\nALL its tasks, costs, photos and related data will be permanently removed. This cannot be undone.",
    projectDeleted: "Project deleted",
    orientPortrait: "Portrait", orientLandscape: "Landscape",
    activitySummary: "Activity Summary", summaryAsOf: "As of",
    delayed: "Delayed", atRisk: "At Risk", early: "Early", inProgress: "In Progress", completed: "Completed",
    completedEarly: "Completed Ahead",
    daysLate: "days late", daysCarryover: "days carryover", daysAhead: "days ahead",
    blockedBy: "Blocked by", plannedEnd: "Planned end",
    noDelayed: "No delayed activities.", noAtRisk: "No at-risk activities.", noEarly: "No activities finished ahead of schedule yet.",
    summaryText: "Executive summary", expandDetail: "click to expand",
    lastUpdate: "Last update", progressReported: "Progress reported",
    expectedToday: "Expected today", reportedToday: "Reported today", variance: "Variance", elapsed: "Days elapsed", days: "days",
    scurveStatus_behind: "Behind", scurveStatus_ahead: "Ahead", scurveStatus_on_track: "On Track",
    scurveHintBehind: "Reported progress is {v}% below expected. Review delayed tasks and adjust resources.",
    scurveHintAhead: "Reported progress exceeds expected by {v}%. Project is ahead — great performance.",
    scurveHintOnTrack: "Reported progress is within ±3% of expected. Project is on schedule.",
    resourcesCatalog: "Resources", resourcesHint: "Master catalogue of resources (labor, equipment, materials, explosives, services).",
    newResource: "New Resource", editResource: "Edit Resource", noResources: "No resources registered.",
    unitCost: "Unit Cost", unit: "Unit", quantity: "Quantity", note: "Note",
    res_labor: "Labor", res_equipment: "Equipment", res_material: "Material", res_explosive: "Explosive", res_service: "Service", res_other: "Other",
    taskTemplates: "Task Templates", templatesHint: "Pre-designed tasks with typical resources for reuse across projects.",
    newTemplate: "New Template", editTemplate: "Edit Template", noTemplates: "No templates registered.",
    durationDays: "Duration (days)", resourcesNeeded: "Resources needed", addResource: "Add resource",
    noResourcesInTemplate: "This template has no resources yet.",
    description: "Description", type: "Type",

    // Login tutorial modal
    tutorialOpen: "How to use UG Managment by OOMINING",
    tutorialTitle: "UG Managment by OOMINING quick guide",
    tutorialSubtitle: "Explore every module. Tap a section to expand it.",
    tutorialFooter: "You can reopen this guide anytime from the login screen.",
    tutorialClose: "Got it",
    tutDashboardTitle: "Dashboard",
    tutDashboardSub: "Portfolio-wide KPIs.",
    tutDashboardBullets: [
      "See active projects, total budget and actual cost at a glance.",
      "Track average progress and open safety incidents.",
      "Frequency (FR) and Severity (SR) rates for the period.",
      "Compare Budget vs Actual per project and browse the portfolio from the cards."
    ],
    tutProjectsTitle: "Projects",
    tutProjectsSub: "Create, edit and remove projects.",
    tutProjectsBullets: [
      "New Project: set code, area/level, budget and start/end dates.",
      "Assign a manager and status (Planning, Active, On Hold, Completed).",
      "Deleting a project cascades: tasks, costs and photos are removed.",
      "Open the detail view to manage tasks, costs, photos and download reports."
    ],
    tutGanttTitle: "Schedule (Gantt)",
    tutGanttSub: "Tasks, phases, dependencies and Excel import.",
    tutGanttBullets: [
      "Add tasks with phase, assignee, start, end and % progress.",
      "Set dependencies to compute the critical path and detect carryover delays.",
      "Grouped by phase with its own color; use custom names if your site needs it.",
      "Download the template, fill it in Excel and import tasks in one go.",
      "The activity summary shows Delayed, At Risk and Early activities as of today."
    ],
    tutScurveTitle: "S-Curve",
    tutScurveSub: "Expected vs reported progress.",
    tutScurveBullets: [
      "Automatically computed from tasks and reported %.",
      "Today snapshot compares Expected vs Reported with variance.",
      "Project status: Behind, On Track or Ahead.",
      "Export the S-Curve to PDF (landscape or portrait) or Excel."
    ],
    tutCostsTitle: "Costs",
    tutCostsSub: "Budget, movements and category variance.",
    tutCostsBullets: [
      "Log Planned and Actual movements by category (labor, equipment, materials, explosives, services).",
      "Summary computes category variance and remaining budget.",
      "Use the Resources catalog to standardize unit costs.",
      "Export the cost report as PDF or Excel to share with management."
    ],
    tutSafetyTitle: "Safety",
    tutSafetySub: "Incidents, inspections and KPIs.",
    tutSafetyBullets: [
      "Register incidents: Near Miss, First Aid, Medical Treatment, Lost Time, Fatality.",
      "Track inspections with % compliance and findings.",
      "FR and SR are computed automatically from period man-hours.",
      "See LTI, days lost and average compliance in a single panel.",
      "Export the full safety report to PDF or Excel."
    ],
    tutPhotosTitle: "Project Photos",
    tutPhotosSub: "Visual annex of site progress.",
    tutPhotosBullets: [
      "Upload photos (PNG, JPG or WEBP, max 5 MB) straight from your phone.",
      "Add a caption per photo for context.",
      "Automatically included in the Complete PDF.",
      "Compressed at export time so the PDF is small and easy to share."
    ],
    tutReportsTitle: "PDF / Excel Reports",
    tutReportsSub: "Gantt, S-Curve, Costs, Safety and Complete PDF.",
    tutReportsBullets: [
      "Export each module separately, or the Complete PDF with everything consolidated.",
      "Choose Landscape orientation (recommended for Gantt) or Portrait.",
      "The Complete PDF includes cover, activity summary, Gantt, S-Curve, costs and photo annex.",
      "On mobile use Share to send via WhatsApp or email."
    ],
    tutOfflineTitle: "Offline Mode (PWA)",
    tutOfflineSub: "Keep working underground without internet.",
    tutOfflineBullets: [
      "Install UG Managment by OOMINING on your phone from the browser menu (Add to Home Screen).",
      "With no signal the app works with cached data.",
      "Changes go into a local queue and sync automatically when back online.",
      "A banner at the top shows pending changes to sync."
    ],
    tutSettingsTitle: "Settings & Catalogs",
    tutSettingsSub: "Brand, theme and master data.",
    tutSettingsBullets: [
      "Upload the company logo (shown in the sidebar and PDFs).",
      "Customize brand colors (Primary, Accent, Success, Danger) or use a preset.",
      "Configure master Resources (with unit cost) and Task Templates.",
      "Adjust period man-hours for FR/SR calculation."
    ],
    tutUsersTitle: "Users & Roles",
    tutUsersSub: "Role-based access control.",
    tutUsersBullets: [
      "Administrator: full access, manages users and catalogs.",
      "Manager: creates projects, tasks, costs, safety and reports.",
      "Supervisor: registers progress, incidents and inspections.",
      "Viewer: read-only dashboards and reports."
    ],

    // Notifications
    notifications: "Notifications",
    noNotifications: "No notifications. Anything relevant to your projects will show up here.",
    markAllRead: "Mark all as read",

    // Share links
    shareLinkButton: "Share link",
    shareLinkTitle: "Share report via public link",
    shareLinkSubtitle: "Generate a time-limited link for project {code}. Whoever receives it can download the Complete PDF without signing in.",
    shareLinkGenerate: "New link",
    shareLinkTtl: "Expires in",
    shareLinkOrient: "PDF orientation",
    shareLinkCreate: "Generate link",
    shareLinkCreated: "Link generated and added below",
    shareLinkCopied: "Link copied to clipboard",
    shareLinkCopyManual: "Copy this link manually:",
    shareLinkRevokeConfirm: "Revoke this link? It will stop working immediately.",
    shareLinkRevoked: "Link revoked",
    shareLinkRevokedTag: "Revoked",
    shareLinkExpiredTag: "Expired",
    shareLinkExpires: "Expires:",
    shareLinkHits: "{n} hits",
    shareLinkActive: "Project links",
    shareLinkNone: "You have not generated any links for this project yet.",
    shareTtl1h: "1 hour",
    shareTtl24h: "24 hours",
    shareTtl7d: "7 days",
    copy: "Copy",
    copied: "Copied",

    // Task resources & detail
    assignedResources: "Assigned resources",
    noResourcesAssigned: "No resources assigned to this task.",
    addResource: "Add resource",
    selectResource: "Pick from catalog…",
    customResource: "Custom…",
    resourceName: "Resource name",
    qty: "Qty",
    unit: "Unit",
    resourceNote: "Note",
    duration: "Duration",
    days: "days",
    dependencies: "Dependencies",
    blocks: "Blocks",
    progressHistory: "Progress history",
    noProgressHistory: "No progress updates recorded yet.",
    loading: "Loading…",
    taskStatusDelayed: "Delayed",
    taskStatusAtRisk: "At risk",
    taskStatusEarly: "Early",
    taskStatusOnTrack: "On track",
    progressEvents: "Reported updates",
    noProgressEvents: "No updates on this date",
    myWork: "My Work",
    myTasks: "My Tasks",
    myActions: "My HSE Actions",
    myCerts: "My Certifications",
    noMyTasks: "You have no tasks assigned right now.",
    noMyActions: "No pending HSE actions.",
    noMyCerts: "All your certifications are up to date.",
    myWorkHint: "Consolidated view of your current workload: assigned tasks, pending HSE actions and certifications about to expire.",
    overdue: "Overdue",
    dueIn: "Due in",
    daysLeft: "days",
    priorityHigh: "High", priorityMedium: "Medium", priorityLow: "Low",
    hrProfile: "Employee profile",
    notInHR: "You don't have an HR profile yet. Ask an admin to link you to see your certifications.",
    verifyPdfLink: "Verify authenticity of a SGSSO PDF",
    verifyPdfHint: "Auditors and clients can validate any signed report without needing an account.",
    verifyPdfTitle: "PDF Verifier",
    verifyPdfHeading: "Verify a SGSSO report's authenticity",
    verifyPdfBlurb: "Upload the PDF and we'll extract its SHA-256 electronic signature. If the hash matches a report issued by this system, we'll show its source data. No login required.",
    verifyDropHere: "Drop your PDF here or click to browse",
    verifyClickToBrowse: "Max 15 MB · .pdf files only",
    verifyValidating: "Validating electronic signature…",
    verifyOkBadge: "AUTHENTIC DOCUMENT",
    verifyNoSigBadge: "No electronic signature",
    verifyNotFoundBadge: "SIGNATURE NOT FOUND",
    verifyKind: "Module",
    verifyGeneratedAt: "Generated (UTC)",
    verifyGeneratedBy: "Signed by",
    verifyRecords: "Records included",
    verifyFrom: "From",
    verifyTo: "To",
    verifyCompany: "Company",
    verifyContract: "Contract",
    verifyFoundInPdf: "found in the PDF",
    verifyErrNotPdf: "The file must be a PDF.",
    verifyErrGeneric: "Could not verify the PDF. Please try again.",
    verifyHow1: "The SHA-256 signature is generated when the report is emitted and stored inside the PDF metadata.",
    verifyHow2: "Any tampering with the content invalidates the signature and the report no longer matches.",
    verifyHow3: "The verifier is public and requires no authentication — rate-limited to 10 checks per 5 minutes per IP.",
    // Change Password (forced on must_change_password)
    cpTitle: "Change your temporary password",
    cpBanner: "Your account was created with a temporary password. Before you continue, pick a password only you know.",
    cpCurrent: "Temporary password",
    cpNew: "New password",
    cpConfirm: "Confirm new password",
    cpHint: "At least 8 characters — must include uppercase, lowercase and a number.",
    cpSubmit: "Save and continue",
    cpLogout: "Sign out",
    cpSuccess: "Password updated. Welcome!",
    cpMismatch: "Passwords do not match.",
    cpTooShort: "New password must be at least 8 characters.",
    // Forgot / Reset password (public)
    forgotPasswordLink: "Forgot your password?",
    fpTitle: "Reset password",
    fpBlurb: "Enter your account email and we'll send a link to pick a new password. The link expires in 30 minutes.",
    fpSubmit: "Send link",
    fpBackLogin: "Back to sign in",
    fpSentTitle: "Check your inbox",
    fpSentBody: "If the email belongs to an active account, you'll receive a link to reset your password.",
    fpSentSpam: "If you don't see it in a few minutes, check your spam folder.",
    rpTitle: "New password",
    rpBlurb: "Pick a password only you know. Same policy applies as everywhere else in the system.",
    rpSubmit: "Save and continue",
    rpSuccess: "Password reset",
    rpSuccessBody: "You can now sign in with your new password.",
    rpGoLogin: "Go to sign in",
    rpNoToken: "Invalid or incomplete link",
    rpRequestNew: "Request a new link",
    // Security status (public panel on /verify)
    secStatusTitle: "Platform Security Status",
    secStatusBlurb: "Active security controls in this deployment. Audited by engineering and validated with automated tests. External auditors may request the full technical detail under NDA.",
    secStatusFooter: "Last internal audit · Feb 2026",
    secBadgeBcrypt: "Bcrypt password hashing",
    secBadgeBcryptSub: "Hash + random salt · never plaintext · policy min. 8 chars with upper/lower/number.",
    secBadgeJwt: "HttpOnly JWT sessions",
    secBadgeJwtSub: "Cookies with secure + samesite=none · inaccessible to JS · 7-day TTL.",
    secBadgeBrute: "Brute-force protection",
    secBadgeBruteSub: "5 failed attempts → 15-minute lockout · distributed IP-based rate limit.",
    secBadgeAudit: "Audit trail",
    secBadgeAuditSub: "All critical events (login/backup/permissions) retained for 90 days.",
    secBadgeBackup: "Automated backups",
    secBadgeBackupSub: "Snapshot every 6h + mirrored redundant database for express recovery.",
    secBadgeSha: "SHA-256 signed PDFs",
    secBadgeShaSub: "Every HSE report is electronically signed and verifiable in this portal.",
    secBadgeCors: "Restricted CORS",
    secBadgeCorsSub: "Only whitelisted domains may issue credentialed requests. Wildcard blocked.",
    secBadgeOffline: "Secure offline mode",
    secBadgeOfflineSub: "Session cached 7 days in IndexedDB · never stores plaintext password or token.",
    offlineBanner: "OFFLINE MODE",
    offlineBannerHint: "Data you capture is stored locally and will sync when signal returns",
    offlineDetected: "No connection detected",
    cachedSessionAvailable: "We found an active session on this device. You can keep working offline; your changes will sync when signal returns.",
    cachedSessionExpires: "Offline session expires",
    continueOffline: "Continue offline session",
    resumedOfflineToast: "Offline session resumed. Remember to sync when you get signal again.",
    shiftOwnerEmpty: "No shift owner",
    shiftOwnerChipEmptyTitle: "Assign a shift operator to this device",
    shiftOwnerChipActiveTitle: "Current shift operator · click to change",
    shiftOwnerDialogTitle: "Shift operator",
    shiftOwnerDialogHint: "Pick which worker is physically using this device. Every observation, toolbox talk or investigation captured will be attributed to this person — helpful when the tablet is passed hand-to-hand underground.",
    shiftOwnerSearchPlaceholder: "Search by name, role, crew or ID…",
    shiftOwnerNoMatches: "No matches in the active directory.",
    shiftOwnerAssigned: "{name} assigned to this device's shift",
    shiftOwnerCleared: "Shift ended",
    shiftOwnerStartedAt: "Shift started",
    shiftOwnerEndShift: "End shift",
    shiftOwnerTag: "Shift",
    finAnalysisTitle: "Financial Analysis",
    finAnalysisSubtitle: "Profitability per LM · Cash flow · Equipment ROI",
    hrReqSubtitle: "Vacation · leave · medical requests",
    hrReqNoPending: "No pending requests",
    hrReqPendingN: "pending",
    hrReqStatusFilter: "Status",
    hrReqStatusPending: "Pending",
    hrReqStatusApproved: "Approved",
    hrReqStatusRejected: "Rejected",
    hrReqStatusAll: "All",
    hrReqExportBtn: "Export Excel",
    hrReqExportedToast: "Requests Excel downloaded",
    hrReqLoading: "Loading requests…",
    hrReqEmptyPending: "No pending requests to review.",
    hrReqEmptyOther: "No requests in this status.",
    hrReqColEmployee: "Employee",
    hrReqColType: "Type",
    hrReqColRange: "Range",
    hrReqColReason: "Reason",
    hrReqColRequested: "Requested",
    hrReqColStatus: "Status",
    hrReqColActions: "Actions",
    hrReqBtnApprove: "Approve",
    hrReqBtnReject: "Reject",
    hrReqApproveDialogTitle: "Approve request",
    hrReqRejectDialogTitle: "Reject request",
    hrReqReviewNote: "Review note (optional)",
    hrReqPlaceholderApprove: "Approved by management",
    hrReqPlaceholderReject: "Rejection reason",
    hrReqAutoDaysInfo: "The days in the range will be automatically marked as {type} in the employee's attendance.",
    hrReqCancel: "Cancel",
    hrReqProcessing: "Processing…",
    hrReqApprovedToast: "Approved",
    hrReqRejectedToast: "Request rejected",
    hrReqDaysMarked: "day(s) marked in attendance",
    hrReqEmailSent: "Notification sent to the employee by email",
    hrReqEmailNoAddress: "The employee has no linked email — notification not sent",
    hrReqEmailNoConfig: "Resend not configured — no email notification",
    hrReqNotePrefix: "Note",
    hrReqReviewedByPrefix: "By",
    hrReqTypeVacation: "Vacation",
    hrReqTypePermit: "Leave",
    hrReqTypeMedical: "Medical",
    hrReqAgo: "",
    hrReqMinShort: "min ago",
    hrReqHourShort: "h ago",
    hrReqDayShort: "d ago",
    obsCountSuffix: "observations",
    hrTabKpis: "KPIs", hrTabPayroll: "Payroll", hrTabSchedule: "Calendar", hrTabAttendance: "Attendance",
    hrTabRequests: "Requests", hrTabCerts: "Certifications", hrTabOrgchart: "Org Chart",
    hrTabVacancies: "Vacancies", hrTabTalent: "Talent Pool", hrTabReimb: "Reimbursements",
    hrTabSignatures: "Signatures log",
    hrTabWhatsApp: "WhatsApp · Twilio",
    hrPdfGeneral: "HR General Report", hrPdfPayroll: "Payroll", hrPdfCalendar: "Calendar / Attendance",
    hrPdfCerts: "Certifications", hrPdfVacancies: "Vacancies", hrPdfReimb: "Reimbursements",
    hrPdfGenerating: "Generating PDF…",
    hrSubtitle: "Personnel management · Crews · Calendar · Attendance",
    weeklySenderUnverified: "Resend is using the sandbox sender 'onboarding@resend.dev' — it only ships to your own account. Verify a domain at resend.com/domains and update SENDER_EMAIL on the backend.",
    shiftOwnerReportBtn: "Download shift Excel",
    shiftOwnerReportDownloaded: "Shift report downloaded",
    usersBulkFromHr: "Generate accounts from HR",
    usersBulkTitle: "Generate user accounts for the entire payroll",
    usersBulkHint: "One account will be created for every active employee that doesn't already have a user. You'll get a listing with temporary passwords for printing/distribution. Safe to run repeatedly — it only processes new employees.",
    usersBulkConfirm: "Generate {count} accounts",
    usersBulkNoCandidates: "All active employees already have an account",
    usersBulkCreated: "{count} accounts created · download the CSV with credentials",
    usersBulkDownloadCsv: "Download credentials (CSV)",
    dashboardMyStats: "My activity this week",
    dashboardTeamStats: "My team's activity",
    kpiMetersYtd: "Meters advanced (YTD)",
    kpiVsBudget: "vs Budget",
    hrQrPortal: "QR Portal", hrCareersPortal: "Careers portal",
    dashOpShifts: "My shifts", dashOpShiftsHint: "captured this week",
    dashOpHours: "Hours worked", dashThisWeek: "this week",
    dashOpObservations: "Observations I reported", dashOpObservationsHint: "safety contribution",
    dashOpToolbox: "Toolbox talks attended", dashOpToolboxHint: "this week",
    dashOpRecentShifts: "My recent shifts",
    dashSupTeamShifts: "Team shifts", dashSupOpenObs: "Open observations",
    dashSupOpenObsHint: "need your review", dashSupPendingHr: "HR requests",
    dashSupPendingHrHint: "awaiting approval", dashSupCompliance: "Compliance",
    dashSupTeamActivity: "Team activity (7 days)",
    "role.admin": "Administrator", "role.owner": "Owner", "role.manager": "Manager",
    "role.director": "Director", "role.jefatura": "Head", "role.supervisor": "Supervisor",
    "role.operador": "Operator", "role.mecanico": "Mechanic", "role.perforista": "Driller",
    "role.almacenista": "Warehouse", "role.viewer": "Viewer",
    operator: "Operator", equipment: "Equipment", hours: "Hours",
    hrReqTypeVacation: "Vacation", hrReqTypePermit: "Leave", hrReqTypeMedical: "Medical",
    dashInlineHrTitle: "Pending approvals · resolve from here",
    dashInlineObsTitle: "Open observations · close urgent ones",
    dashInlineQuickClosed: "Closed from the dashboard",
    hrCareersLinkCopied: "Careers portal link copied",
    hse: "HSE",
    hseSubtitle: "Health, Safety & Environment Management System",
    hr: "Human Resources",
    finAnalysis: "Financial Analysis",
    maintenance: "Diesel Maintenance",
    camp: "Camp",
    campSubtitle: "Rooms · Occupants · Laundry · Water",
    campTabLayout: "Layout", campTabRooms: "Rooms", campTabLaundry: "Laundry", campTabWater: "Water",
    campNoRooms: "No rooms yet. Create the first one to get started.",
    campNewRoom: "New room", campEditRoom: "Edit room",
    campRoomNumber: "Number", campRoomBlock: "Block / Module", campRoomFloor: "Floor",
    campRoomCapacity: "Capacity (beds)", campRoomNotes: "Notes",
    campRoomWidth: "Width (cells)", campRoomHeight: "Height (cells)",
    campAssignOccupant: "Assign occupant", campReleaseOccupant: "Release",
    campSelectEmployee: "Select employee…", campBedLabel: "Bed / bunk",
    campEmpty: "Empty room", campFull: "Room full",
    campOccupancy: "Occupancy", campBeds: "beds",
    campRooms: "Rooms", campOccupants: "Occupants", campBlocks: "Blocks",
    campLaundryHint: "Weekly laundry rotation. Assign one responsible per day per block; occupants are auto-linked.",
    campLaundryDay: "Day", campLaundryResponsible: "Responsible", campLaundryWeekOf: "Week of",
    campWaterTitle: "Water consumption calculator",
    campWaterHint: "Based on personnel on site (camp occupants). Default standard is 150 L/person/day (mining camp domestic).",
    campWaterLitersPerson: "Liters per person/day", campWaterDays: "Days in period",
    campWaterHeadcount: "Headcount on site (auto)",
    campWaterDaily: "Daily consumption", campWaterPeriod: "Period consumption",
    campWaterStandards: "Reference standards",
    campWaterCompute: "Compute", campWaterFormula: "Formula",
    campSourceCamp: "Camp occupants", campSourceHr: "Active HR", campSourceManual: "Manual",
    dayShort0: "Mon", dayShort1: "Tue", dayShort2: "Wed", dayShort3: "Thu", dayShort4: "Fri", dayShort5: "Sat", dayShort6: "Sun",
    operations: "Operations", bitacora: "Logbook", inventory: "Inventory", finance: "Finance",
    pdfReports: "PDF Reports", fieldReport: "Field report",
    menu: "Menu", hide: "Hide", hideMenu: "Hide menu", expandMenu: "Expand menu",
    hseTabKpis: "KPIs", hseTabTargets: "Targets", hseTabIper: "HIRA", hseTabBowtie: "Bow-Tie", hseTabDaily: "Daily Report", hseFieldReport: "Field report",
    hseTabJsa: "JSA", hseTabPermits: "Permits", hseTabObservations: "OCAS",
    hseTabToolbox: "Toolbox Talks", hseTabInvestigations: "Investigations",
    hseTabActions: "Actions", hseTabNormAudit: "Normative Audit", hseTabMedical: "Medical Tests", hseTabEpp: "PPE Delivery", hseTabSupervisor: "First-line Supervisor", hseTabDriverLicenses: "Driver Licenses", hseTabLegacy: "Incidents / Inspections",
    semaforoHealthy: "HEALTHY", semaforoAmber: "AMBER ALERT", semaforoRed: "RED ALERT",
    obsOpenSuffix: "open",
    obsReportBtn: "Report observation",
    obsNewTitle: "New safety observation",
    obsEditTitle: "Edit observation",
    obsFieldType: "Type",
    obsFieldArea: "Area / Level",
    obsFieldDesc: "Description",
    obsFieldAction: "Immediate action taken",
    obsFieldSeverity: "Severity",
    obsFieldPhotos: "Photos (optional · up to 6)",
    obsKindUnsafeAct: "Unsafe act",
    obsKindUnsafeCondition: "Unsafe condition",
    obsKindPositive: "Positive observation",
    obsSevLow: "Low",
    obsSevMedium: "Medium",
    obsSevHigh: "High",
    obsPlaceholderArea: "e.g. Gallery 850",
    obsPlaceholderDesc: "What did you see?",
    obsPlaceholderAction: "Removed personnel, notified supervisor…",
    obsSubmit: "Submit",
    obsUpdateSubmit: "Save changes",
    obsSavedToast: "Observation recorded",
    obsUpdatedToast: "Observation updated",
    obsClosedToast: "Closed",
    obsClosedBadge: "Closed",
    obsActionShort: "Action",
    obsResolutionLabel: "Resolution",
    obsEdit: "Edit",
    obsClose: "Close",
    obsNoObservations: "No observations",
    obsDeleteConfirm: "Delete this observation?",
    obsResolveTitle: "Close observation",
    obsResolveNote: "Resolution note",
    obsResolveConfirm: "Confirm close",
    obsFieldResponsible: "Follow-up responsible",
    obsResponsibleHint: "Assigning triggers auto-creation of a linked corrective action",
    obsLinkedActionBadge: "Linked action",
    obsOcasFullName: "OCAS · Substandard Conditions & Acts Observation",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "es");
  const t = (key, params) => {
    const raw = dict[lang][key] || dict.en[key] || key;
    if (!params) return raw;
    return String(raw).replace(/\{(\w+)\}/g, (_m, k) => (params[k] !== undefined ? params[k] : `{${k}}`));
  };
  const switchLang = (l) => { setLang(l); localStorage.setItem("lang", l); };
  return <LangContext.Provider value={{ lang, t, switchLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
